var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTerminologyTranslation } from '../../app/terminology';
import { AnnualSectionTable } from '../common/annualSectionTable';
import { MultigeoLobRow } from '../common/multigeoQueuesByLob';
import { MultiskillGroupRows } from '../common/multiskillGroupRow';
import { getQueueExpansionKeysForLob, useMultiskillGroupExpansionKeys, useMultiskillGroupNames, useQueueExpansionKeys, useSelectQueuesByLobPerScenario, } from '../common/selectors';
import { getLobExpansionKey } from '../constants';
import { useSelectCurrency, useSummaryByDisplayMode, useSummaryChunkSize } from '../selectors';
var CostPerWorkSection = function (_a) {
    var expandedItems = _a.expandedItems, onToggleItem = _a.onToggleItem;
    var data = useSummaryByDisplayMode();
    var chunkSize = useSummaryChunkSize();
    var lobsPerScenario = useSelectQueuesByLobPerScenario();
    var multiskillGroupNames = useMultiskillGroupNames(data !== null && data !== void 0 ? data : []);
    if (!data || !lobsPerScenario.length)
        return null;
    return (_jsxs(_Fragment, { children: [lobsPerScenario.map(function (lobEntry) { return (_jsx(MultigeoLobRow, { lob: lobEntry.template, perScenarioLob: lobEntry.perScenarioLob, data: data, chunkSize: chunkSize, keyItem: "costPerWork", hideConstraintHeader: true, expandedItems: expandedItems, onToggleItem: onToggleItem }, "costPerWork-".concat(lobEntry.lobName))); }), _jsx(MultiskillGroupRows, { groupNames: multiskillGroupNames, data: data, chunkSize: chunkSize, valueKey: "costPerWork", expandedItems: expandedItems, onToggleItem: onToggleItem })] }));
};
export var CostPerWorkTable = function () {
    var t = useTerminologyTranslation('report', { keyPrefix: 'annual' }).t;
    var lobsPerScenario = useSelectQueuesByLobPerScenario();
    var queues = useQueueExpansionKeys(lobsPerScenario);
    var data = useSummaryByDisplayMode();
    var multiskillExpansionItems = useMultiskillGroupExpansionKeys(data !== null && data !== void 0 ? data : []);
    var currency = useSelectCurrency();
    var getNestedExpansionItems = React.useCallback(function (itemName) {
        var lobEntry = lobsPerScenario.find(function (_a) {
            var lobName = _a.lobName;
            return getLobExpansionKey(lobName) === itemName;
        });
        if (!lobEntry)
            return [];
        return getQueueExpansionKeysForLob(lobEntry);
    }, [lobsPerScenario]);
    return (_jsx(AnnualSectionTable, { title: t('costPerWorkType', { currency: currency }), unit: t('cost'), expansionItems: __spreadArray(__spreadArray(__spreadArray([], lobsPerScenario.map(function (_a) {
            var lobName = _a.lobName;
            return getLobExpansionKey(lobName);
        }), true), queues, true), multiskillExpansionItems, true), getNestedExpansionItems: getNestedExpansionItems, tableBodyComponent: CostPerWorkSection }));
};
